import { useQueryClient } from "@tanstack/react-query";

import {
    getGetControlProgramsQueryKey,
    usePostControlPrograms,
} from "api/generated/control-program/control-program";
import { getEntityCountQueryKey } from "api/generated/entities/entities";

export function useCreateControlProgramMutation(
    onCreateSuccess?: (id: number) => void
) {
    const queryClient = useQueryClient();
    return usePostControlPrograms({
        mutation: {
            onSuccess: (response, variables) => {
                queryClient.invalidateQueries({
                    queryKey: getGetControlProgramsQueryKey(),
                });
                variables.data.controlEntityIds.forEach((entityId) => {
                    queryClient.invalidateQueries({
                        queryKey: getEntityCountQueryKey(entityId),
                    });
                });
                if (onCreateSuccess) {
                    onCreateSuccess(
                        response.data.content.resource.controlProgram.id
                    );
                }
            },
        },
    });
}
